<template>
  <div class="EditTrade">
    <div class="button-holder top-btn-holder" v-if="isShowNavigate">
      <div class="btn-item back-item">
        <button class="back" @click="isEditTrade = false; isNewTrade = false">
          <img class="long-arrow light-arrow" src="/img/long-arrow.png" alt="">
          <img class="long-arrow dark-arrow" src="/img/long-arrow-dark.png" alt="">
          <span>Special Trades</span>
        </button>
      </div>
      <div class="btn-item">
        <button class="btn" @click="generateDoc()">Generate doc</button>
      </div>
    </div>

    <generate-doc v-if="isGenerateDoc" />
    <div v-else>
      <form class="gen-form" data-form="profile">
        <div class="gen-fieldset__item">
          <span class="key">ID</span>
          <span class="value">{{ currentProgram.id }}</span>
        </div>
        <div class="gen-fieldset__item">
          <span class="key">Active</span>
          <span class="value">{{ currentProgram.active === '1' ? 'true' : 'false' }}</span>
        </div>
        <div class="gen-fieldset__item">
          <span class="key">Type</span>
          <span class="value">
            {{ currentProgram.type_name ? currentProgram.type_name : currentProgram.name}}
          </span>
        </div>
        <div class="gen-fieldset__item">
          <label>Commited $</label>
          <input type="text" v-model="currentProgram.committed">
        </div>
        <div class="gen-fieldset__item">
          <span class="key">Start date</span>
          <span class="value">{{ currentProgram.start_date }}</span>
        </div>
        <div class="gen-fieldset__item">
          <label>End date</label>
          <input type="text" v-model="currentProgram.end_date">
        </div>
        <div class="gen-fieldset__item">
          <span class="key">Asset</span>
          <span class="value">{{ currentProgram.asset }}</span>
        </div>
        <div class="gen-fieldset__item">
          <span class="key">Operation</span>
          <span class="value">{{ currentProgram.operation }}</span>
        </div>
        <div class="gen-fieldset__item">
          <span class="key">Current price $</span>
          <span class="value">{{ currentProgram.current_price }}</span>
        </div>
        <div class="gen-fieldset__item">
          <label>Special price $</label>
          <input type="text" v-model="currentProgram.special_price">
        </div>
        <div class="gen-fieldset__item">
          <span class="key">Created at</span>
          <span class="value">{{ currentProgram.created_at }}</span>
        </div>
        <div class="gen-fieldset__item">
          <span class="key">Created by</span>
          <span class="value">{{ currentProgram.user_name }}</span>
        </div>
        <div class="updateBtn">
          <button class="btn" @click.prevent="update">Update</button>
          <span class="success" v-if="success">{{success}}</span>
        </div>
        <div class="total-block">
          <div v-if="error" class="error">{{ error }}</div>
          <span class="total-key">Total deposited</span>
          <span class="total-value">${{ currentProgram.total_deposited }}</span>
        </div>
      </form>
      <table class="table-basic trade-total" v-if="deposits.length">
        <tbody>
        <tr v-for="item in deposits">
          <td>{{ item.dd | moment("DD/MM/YYYY HH:MM:SS") }}</td>
          <td>{{ item.clearedby }}</td>
          <td>{{ item.reply }}</td>
          <td>$ {{ item.amount }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import GenerateDoc from "../partials/GenerateDoc";
import LeadDataService from "../../../../services/lead-data.service";

export default {
  name: "EditTrade",
  components: {GenerateDoc},
  data() {
    return {
      deposits: [],
      success: '',
      error: '',
      isGenerateDoc: false,
      form: {
        committed: '',
        end_date: '',
        special_price: ''
      }
    }
  },
  computed: {
    isNewTrade: {
      get() {
        return this.$store.state.isNewTrade;
      },
      set(value) {
        this.$store.commit('setter', {isNewTrade: value})
      }
    },
    isEditTrade: {
      get() {
        return this.$store.state.isEditTrade;
      },
      set(value) {
        this.$store.commit('setter', {isEditTrade: value})
      }
    },
    isShowNavigate() {
        return this.$store.state.isShowNavigate;
    },
    currentProgram: {
      get() {
        return this.$store.state.currentProgram;
      },
      set(value) {
        this.$store.commit('setter', {currentProgram: value})
      }
    },
  },
  mounted() {
    this.getLast();
  },
  methods: {
    getLast() {
      const query = {
        action: 'get',
        id: this.currentProgram.id,
      };
      LeadDataService.getPrograms(query).then((res) => {
        this.deposits = res.data.data.deposits;
      }).catch((error) => {
        this.error = !error.response.data.result ? error.response.data.message : '';
      })
    },
    update() {
      this.form = {
        action: 'edit',
        id: this.currentProgram.id,
        committed: this.currentProgram.committed,
        end_date: this.currentProgram.end_date,
        special_price: this.currentProgram.special_price,
      };

      LeadDataService.getPrograms(this.form).then((res) => {
        this.error = '';
        this.success = res.data.result ? res.data.message : '';
      }).catch((error) => {
        this.error = !error.response.data.result ? error.response.data.message : '';
      })
    },
    generateDoc() {
      this.isGenerateDoc = true;
    }
  }
}
</script>

<style lang="scss">
@import "assets/styles/components/variables";

.EditTrade {
  .error {
    margin-bottom: 10px;
  }

  .gen-form {
    align-items: unset;
  }

  .btn-item {
    width: 50%;

    &.back-item {
      display: flex;
    }
  }

  .updateBtn {
    width: 100%;
    text-align: right;
    margin-bottom: 24px;

    .btn {
      font-size: 14px;
      color: $blueLight;
      font-weight: 500;
    }
  }

  .key,
  .value {
    display: block;
  }

  .key {
    margin-bottom: 8px;
    color: $legend;
    font-size: 14px;
  }

  .value {
    display: block;
    color: #8d8d8d;
  }

  .total-key {
    color: $legend;
    margin-right: 8px;
  }

  .total-value {
    font-weight: 500;
    color: $dark-purple;
  }

  .trade-total {
    tr {
      &:nth-child(2n+1) {
        td {
          &:first-child {
            border-top-left-radius: 22px;
            border-bottom-left-radius: 22px;
          }

          &:last-child {
            border-top-right-radius: 22px;
            border-bottom-right-radius: 22px;
          }
        }
      }

      td {
        padding: 16px 0;

        &:first-child {
          padding-left: 18px;
        }
      }
    }
  }
}
</style>
